module.exports = __webpack_public_path__ + "img/member_shopping_online_icon.c216d2e9.png";